import React, { useEffect, useState } from 'react';
import {
  obtenerFrasesAgrupadas, crearFrase, eliminarFrase,
  obtenerAdicionalesPredef, crearAdicionalPredef, eliminarAdicionalPredef,
} from '../services/serviciosService';
import { formatoMoneda } from '../utils/servicios';
import { useAuth } from '../context/AuthContext';
import { mensajeAmigable } from '../utils/errores';
import { useToast } from '../context/ToastContext';
import CampoNumero from './CampoNumero';

// Biblioteca de frases reutilizables del negocio. Se configuran una vez y luego
// se seleccionan con un clic al crear un servicio (¿qué incluye? / no incluye /
// requisitos). Pensado para agentes de viajes y cualquier rubro de servicios.

const P = 'var(--color-primario,#DB2777)';
const input = { width: '100%', padding: '10px', border: '1px solid #D1D5DB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' };

const SECCIONES = [
  { tipo: 'incluye', titulo: '¿Qué incluye?', icono: '✓', color: '#059669', placeholder: 'Ej. Traslados aeropuerto-hotel' },
  { tipo: 'no_incluye', titulo: 'No incluye', icono: '✗', color: '#DC2626', placeholder: 'Ej. Comidas y bebidas' },
  { tipo: 'requisito', titulo: 'Requisitos', icono: '📋', color: '#4338CA', placeholder: 'Ej. Pasaporte vigente' },
];

function Seccion({ def, frases, onAgregar, onEliminar }) {
  const [texto, setTexto] = useState('');
  const [guardando, setGuardando] = useState(false);
  const agregar = async () => {
    const v = texto.trim();
    if (!v) return;
    setGuardando(true);
    try { await onAgregar(def.tipo, v); setTexto(''); }
    finally { setGuardando(false); }
  };
  return (
    <div style={{ marginBottom: '20px' }}>
      <p style={{ margin: '0 0 8px', fontSize: '14px', fontWeight: 700, color: def.color }}>{def.icono} {def.titulo}</p>
      <div style={{ display: 'flex', gap: '6px', marginBottom: '8px' }}>
        <input value={texto} maxLength={120} disabled={guardando} placeholder={def.placeholder}
          onChange={(e) => setTexto(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); agregar(); } }}
          style={{ ...input, flex: 1 }} />
        <button type="button" onClick={agregar} disabled={guardando}
          style={{ padding: '0 16px', borderRadius: '8px', border: `1px solid ${P}`, background: P, color: '#fff', fontWeight: 700, cursor: 'pointer' }}>Agregar</button>
      </div>
      {frases.length === 0
        ? <p style={{ margin: 0, fontSize: '12.5px', color: '#9CA3AF' }}>Todavía no agregaste frases aquí.</p>
        : (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
            {frases.map((f) => (
              <span key={f.id} style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', background: '#F3F4F6', borderRadius: '999px', padding: '5px 10px', fontSize: '12.5px', color: '#374151' }}>
                {f.texto}
                <button type="button" onClick={() => onEliminar(f.id)} title="Eliminar"
                  style={{ background: 'none', border: 'none', color: '#9CA3AF', cursor: 'pointer', fontSize: '13px', lineHeight: 1 }}>×</button>
              </span>
            ))}
          </div>
        )}
    </div>
  );
}

// Adicionales frecuentes: nombre + precio, para seleccionar al crear un servicio.
function SeccionAdicionales({ moneda, adicionales, onAgregar, onEliminar }) {
  const [nombre, setNombre] = useState('');
  const [precio, setPrecio] = useState('');
  const [guardando, setGuardando] = useState(false);
  const agregar = async () => {
    const n = nombre.trim();
    if (!n) return;
    setGuardando(true);
    try { await onAgregar({ nombre: n, precio: Number(precio) || 0 }); setNombre(''); setPrecio(''); }
    finally { setGuardando(false); }
  };
  return (
    <div style={{ marginBottom: '20px' }}>
      <p style={{ margin: '0 0 8px', fontSize: '14px', fontWeight: 700, color: '#B45309' }}>➕ Adicionales frecuentes</p>
      <div style={{ display: 'flex', gap: '6px', marginBottom: '8px', alignItems: 'flex-start' }}>
        <input value={nombre} maxLength={80} disabled={guardando} placeholder="Ej. Seguro de viaje"
          onChange={(e) => setNombre(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); agregar(); } }}
          style={{ ...input, flex: 2 }} />
        <div style={{ flex: 1 }}>
          <CampoNumero valor={precio} prefijo={moneda} min={0} deshabilitado={guardando}
            onChange={setPrecio} placeholder="0.00" />
        </div>
        <button type="button" onClick={agregar} disabled={guardando}
          style={{ padding: '10px 16px', borderRadius: '8px', border: `1px solid ${P}`, background: P, color: '#fff', fontWeight: 700, cursor: 'pointer' }}>Agregar</button>
      </div>
      {adicionales.length === 0
        ? <p style={{ margin: 0, fontSize: '12.5px', color: '#9CA3AF' }}>Todavía no agregaste adicionales.</p>
        : (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
            {adicionales.map((a) => (
              <span key={a.id} style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', background: '#FEF3C7', borderRadius: '999px', padding: '5px 10px', fontSize: '12.5px', color: '#78350F' }}>
                {a.nombre} · {formatoMoneda(a.precio, moneda)}
                <button type="button" onClick={() => onEliminar(a.id)} title="Eliminar"
                  style={{ background: 'none', border: 'none', color: '#B45309', cursor: 'pointer', fontSize: '13px', lineHeight: 1 }}>×</button>
              </span>
            ))}
          </div>
        )}
    </div>
  );
}

export default function FrasesRapidasModal({ onCerrar, onCambio }) {
  const { negocio } = useAuth();
  const moneda = negocio?.moneda || 'L';
  const { mostrarToast } = useToast();
  const [grupos, setGrupos] = useState({ incluye: [], no_incluye: [], requisito: [] });
  const [adicionales, setAdicionales] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(null);

  const cargar = async () => {
    try {
      const [g, a] = await Promise.all([obtenerFrasesAgrupadas(), obtenerAdicionalesPredef()]);
      setGrupos(g); setAdicionales(a); setError(null);
    }
    catch (e) { setError(mensajeAmigable(e)); }
    finally { setCargando(false); }
  };
  useEffect(() => { cargar(); }, []);

  const agregarAdic = async (datos) => {
    try {
      const nuevo = await crearAdicionalPredef(datos);
      setAdicionales((prev) => [...prev, nuevo]);
      onCambio && onCambio();
    } catch (e) { mostrarToast(mensajeAmigable(e), 'error'); }
  };
  const eliminarAdic = async (id) => {
    try {
      await eliminarAdicionalPredef(id);
      setAdicionales((prev) => prev.filter((a) => a.id !== id));
      onCambio && onCambio();
    } catch (e) { mostrarToast(mensajeAmigable(e), 'error'); }
  };

  const agregar = async (tipo, texto) => {
    try {
      const nueva = await crearFrase({ tipo, texto });
      setGrupos((g) => ({ ...g, [tipo]: [...g[tipo], nueva] }));
      onCambio && onCambio();
    } catch (e) { mostrarToast(mensajeAmigable(e), 'error'); }
  };

  const eliminar = async (id) => {
    try {
      await eliminarFrase(id);
      setGrupos((g) => ({
        incluye: g.incluye.filter((f) => f.id !== id),
        no_incluye: g.no_incluye.filter((f) => f.id !== id),
        requisito: g.requisito.filter((f) => f.id !== id),
      }));
      onCambio && onCambio();
    } catch (e) { mostrarToast(mensajeAmigable(e), 'error'); }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1400, padding: '16px' }} onClick={onCerrar}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: '#fff', borderRadius: '16px', padding: '22px', width: '520px', maxWidth: '100%', maxHeight: '90vh', overflowY: 'auto', boxSizing: 'border-box' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '6px' }}>
          <h2 style={{ margin: 0, color: P, fontSize: '19px' }}>📋 Frases y adicionales</h2>
          <button onClick={onCerrar} style={{ background: 'none', border: 'none', fontSize: '22px', cursor: 'pointer', color: '#9CA3AF' }}>✕</button>
        </div>
        <p style={{ margin: '0 0 18px', fontSize: '13px', color: '#6B7280' }}>
          Guarda acá tus frases y adicionales más usados. Al crear un servicio los vas a poder seleccionar con un clic, sin volver a escribirlos.
        </p>
        {cargando && <p style={{ textAlign: 'center', color: '#6B7280', padding: '16px' }}>⏳ Cargando…</p>}
        {error && <p style={{ textAlign: 'center', color: '#991B1B', fontWeight: 600 }}>⚠️ {error}</p>}
        {!cargando && !error && (
          <>
            {SECCIONES.map((def) => (
              <Seccion key={def.tipo} def={def} frases={grupos[def.tipo] || []} onAgregar={agregar} onEliminar={eliminar} />
            ))}
            <SeccionAdicionales moneda={moneda} adicionales={adicionales} onAgregar={agregarAdic} onEliminar={eliminarAdic} />
          </>
        )}
        <button onClick={onCerrar}
          style={{ width: '100%', marginTop: '4px', padding: '12px', background: P, color: '#fff', border: 'none', borderRadius: '10px', fontSize: '15px', fontWeight: 'bold', cursor: 'pointer' }}>
          Listo
        </button>
      </div>
    </div>
  );
}
